<ion-header class="ion-no-border">

	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>Stripe Terminal reader</ion-title>
		<ion-buttons slot="end">
			<ion-button *ngIf="online" (click)="loadReaders()">
				<fa-icon [icon]="['far', 'sync']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content class="ion-text-center">

	<ion-grid *ngIf="!online" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'wifi-slash']" size="6x"></fa-icon>
                    <span>You are not connected to the internet</span>
                </p>
            </ion-col>
		</ion-row>
	</ion-grid>

	<ion-grid *ngIf="online && !loading_readers && stripe_connected && readers.length === 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'empty-set']" size="6x"></fa-icon>
                    <span>No Stripe Terminal readers found</span>
                </p>
            </ion-col>
		</ion-row>
	</ion-grid>

    <ion-grid *ngIf="online && !loading_readers && !stripe_connected" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'empty-set']" size="6x"></fa-icon>
                    <span>Stripe isn't connected</span>
                </p>
            </ion-col>
		</ion-row>
	</ion-grid>

	<ion-list *ngIf="online && readers && readers.length">
		<ion-item *ngFor="let reader of readers" lines="full">
			<ion-grid>
				<ion-row class="ion-align-items-center">
					<ion-col size="3">{{reader.label}}</ion-col>
					<ion-col size="3">{{reader.serial_number}}</ion-col>
					<ion-col size="2">
						<ion-label [style.color]="reader_connection_status_colors[reader.status]"><fa-icon class="terminal-connection-status-indicator" [icon]="['fas', 'circle']" [style.color]="reader_connection_status_colors[reader.status]"></fa-icon>{{capitalise(reader.status)}}</ion-label>
					</ion-col>
					<ion-col size="2">
						<ion-button *ngIf="(saved_reader && !selected_reader) && saved_reader.id === reader.id" (click)="forgetReader()">Forget</ion-button>
					</ion-col>
					<ion-col size="2">
						<ion-button *ngIf="!selected_reader" [disabled]="reader.status==='offline' || readerService.connection_status === 'connecting'" (click)="update(reader)">Connect</ion-button>
                        <ion-button *ngIf="selected_reader && selected_reader.id === reader.id" (click)="disconnect()">Disconnect</ion-button>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-item>
	</ion-list>

</ion-content>